import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'fuelLevel',
  standalone: false,
})
export class FuelLevelPipe implements PipeTransform {
  transform(fuelLevelML?: number): number | null {
    const fuelLevelL: number | null = fuelLevelML ? Math.ceil(fuelLevelML / 1000) : null
    return fuelLevelL
  }
}
